import React, { memo } from 'react'
import ScrollContainer from '../../ScrollContainer'
import Spinner from '../../Spinner'
import ObjectItem from '../ObjectItem'
import Empty from '../Empty'

const Left = ({
    searchActive,
    searchFounded = [],
    objects = [],
    loading,
    toggleSelected,
}) => {
    const displayedObjects = searchActive ? searchFounded : objects

    const renderContent = () => {
        if (loading) return <Spinner className="pt-xs pb-xs" />
        
        const hasObjects = displayedObjects.length > 0 || searchActive
        
        return (
            <ScrollContainer className="Objects__container-list" size="auto">
                {hasObjects ? (
                    displayedObjects.map(object => (
                        <ObjectItem
                            key={object.id}
                            id={object.id}
                            name={object.name}
                            address={object.address}
                            fullName={object.fullName}
                            mute={object.mute}
                            statusText={object.statusText}
                            leftMarker={object.leftMarker}
                        />
                    ))
                ) : (
                    <Empty title="Объектов пока нет." />
                )}
            </ScrollContainer>
        )
    }

    return (
        <section className="ObjectsLeft Objects__place">
            <div className="Objects__title">Объекты</div>
            <div className="Objects__list" onClick={toggleSelected}>
                {renderContent()}
            </div>
        </section>
    )
}

export default memo(Left)